import React from 'react';
import PropTypes from 'prop-types';
import {AvailExtendedStringField, AvailStringField} from '../../../../value-comparing/helper-components';
import AssetAvailSection from './asset-section';
import TransactionsSection from './transactions-section';
import {ValueComparer} from '../../../../value-comparing/value-comparer';

const valueComparer = new ValueComparer();

const renderRequiredComponent = (valueToRender, previousValue, currentKey) => {
  if (currentKey.toLowerCase() === 'asset') {
    return <AssetAvailSection assetsList={valueToRender} key={currentKey} oldValue={previousValue} />;
  }

  if (currentKey.toLowerCase() === 'transaction') {
    return <TransactionsSection key={currentKey} oldValue={previousValue} transactionCollection={valueToRender} />;
  }

  if (valueComparer.isValue(valueToRender)) {
    return (
      <AvailStringField assignedKey={currentKey} key={currentKey} oldValue={previousValue} value={valueToRender} />
    );
  }

  if (valueComparer.isObject(valueToRender)) {
    return (
      <AvailExtendedStringField
        assignedKey={currentKey}
        key={currentKey}
        oldValue={previousValue}
        value={valueToRender}
      />
    );
  }
};

const AvailResult = ({avail, previousAvailVersion}) => {
  const statusKeyNames = new Set(['timeStamp', 'isNew', 'hasError', 'id']);
  const availKeys = Object.keys(avail);

  const previousAvailKeysNotFoundInsideCurrent = previousAvailVersion
    ? Object.keys(previousAvailVersion)?.filter(
        previousKey => !availKeys.includes(previousKey) && !statusKeyNames.has(previousKey)
      )
    : [];

  return (
    <div>
      {availKeys.map(availKey =>
        !statusKeyNames.has(availKey)
          ? renderRequiredComponent(avail[availKey], previousAvailVersion?.[availKey], availKey)
          : null
      )}
      {previousAvailKeysNotFoundInsideCurrent.length > 0 &&
        previousAvailKeysNotFoundInsideCurrent.map(availKey =>
          !statusKeyNames.has(availKey)
            ? renderRequiredComponent(undefined, previousAvailVersion?.[availKey], availKey)
            : null
        )}
    </div>
  );
};

AvailResult.propTypes = {
  avail: PropTypes.object,
  previousAvailVersion: PropTypes.oneOf(PropTypes.object, PropTypes.bool),
};

export default AvailResult;
